import React from "react";

import { css, cx } from "@emotion/css";
import { EditorContent } from "@tiptap/react";

import { useStyles } from "@/hooks/useStyles.ts";
import { useRichTextEditor } from "@/uiKit/molecules/RichText/RichTextSettings.ts";

export type RichTextViewerProps = {
  className?: string;
  content: string | undefined;
};

export const RichTextViewer: React.FC<RichTextViewerProps> = ({ content, className }) => {
  const styles = useStyles(makeStyles);
  const editor = useRichTextEditor({
    content: content ? JSON.parse(content) : undefined,
    editable: false,
  });
  return (
    <div className={cx(styles.container, className)}>
      <EditorContent editor={editor} className={styles.content} content={content} />
    </div>
  );
};

const makeStyles = () => ({
  container: css({}),
  content: css({
    "& .ProseMirror": {
      outline: "none",
    },
  }),
});
